interface CoverEmployee {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  employeeId?: string | null;
  terminationId?: number | null;
  empNumber?: number | null;
}

interface CoverAssignment {
  status?: string | null;
  coverEmployee?: CoverEmployee | null;
}

const formatName = (employee: CoverEmployee): string => {
  const parts = [
    employee.firstName,
    employee.middleName,
    employee.lastName,
  ].filter((part) => !!part);
  return parts.join(' ') || employee.employeeId || '–';
};

export function formatCoverAssignmentLabel(
  assignment?: CoverAssignment | null,
): string | null {
  if (!assignment || !assignment.coverEmployee) {
    return null;
  }
  const name = formatName(assignment.coverEmployee);
  const status = assignment.status
    ? assignment.status.replace('_', ' ')
    : 'pending';
  return `${name} (${status})`;
}
